import { isOtlpLogEligible } from 'src/observability/resolve-otlp-log-eligibility';
import { emitOtlpLog } from 'src/observability/otel-logs';

/**
 * OTLP log remote transport. No-op when OTLP logs are not initialized.
 *
 * @returns {{ log: Function }}
 */
export const createOtlpLogTransport = () => ({
    log(record) {
        if (!isOtlpLogEligible(record)) {
            return;
        }

        emitOtlpLog(record);
    },
});
